import access from "@/mixin/functions/access";

export default {
    methods: {
        hasRoleAdmin: () => access.hasRoleAdmin(),
    }
}